import weightLossUrl from '/public/icons/nutritionist/weight-loss.svg'
import hypertrophyUrl from '/public/icons/nutritionist/hypertrophy.svg'
import vegetarianUrl from '/public/icons/nutritionist/vegetarian.svg'
import veganUrl from '/public/icons/nutritionist/vegan.svg'
import menopauseUrl from '/public/icons/nutritionist/menopause.svg'
import celiacsUrl from '/public/icons/nutritionist/celiacs.svg'
import lactoseIntolerantUrl from '/public/icons/nutritionist/lactose-intolerant.svg'

export const ITEMS = [
  { iconUrl: weightLossUrl, text: 'Emagrecimento' },
  { iconUrl: hypertrophyUrl, text: 'Hipertrofia' },
  { iconUrl: vegetarianUrl, text: 'Vegetariano' },
  { iconUrl: veganUrl, text: 'Vegano' },
  { iconUrl: menopauseUrl, text: 'Menopausa' },
  { iconUrl: celiacsUrl, text: 'Celíacos' },
  { iconUrl: lactoseIntolerantUrl, text: 'Intolerantes à lactose' }
]
